<template>
  <v-row style="height: calc(100% + 1px);">
    <app-bar :no-back="$attrs['no-back']" v-if="!$attrs['no-bar']">
      <slot name="title"></slot>
    </app-bar>
    <v-col cols="12" class="pa-0">
      <slot></slot>
      <v-footer :dark="footerDark" class="pa-0 mt-n1" app :color="$attrs['footer-color'] || 'primary'">
        <v-row :class="$attrs['footer-class'] || 'text-center'">
          <v-col cols="12" class="pa-0">
            <slot name="footer"></slot>
          </v-col>
        </v-row>
      </v-footer>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    footerDark: { type: Boolean, default: false }
  },
  data () {
    return {
      model: {},
    };
  }
};
</script>
